/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Buy_Week_No_PriceInputs */

const fr_extra_session_buy_week_no_price = /** @type {(inputs: Extra_Session_Buy_Week_No_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter une séance supplémentaire`)
};

/**

* @param {Extra_Session_Buy_Week_No_PriceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_buy_week_no_price = /** @type {((inputs?: Extra_Session_Buy_Week_No_PriceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Buy_Week_No_PriceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_buy_week_no_price(inputs)
});